import { Textarea } from '@mantine/core';

const ChatBotInput = ({ prompt, onSubmit, updatePrompt, disabled }) => {
  const handleEnterClick = (e) => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <Textarea
      value={prompt}
      onChange={(e) => updatePrompt(e.target.value)}
      onKeyDown={handleEnterClick}
      placeholder="Type your message..."
      autosize
      minRows={1}
      maxRows={6}
      disabled={disabled}
      styles={{
        input: {
          border: 'none',
          backgroundColor: 'transparent',
        },
      }}
    />
  );
};

export default ChatBotInput;
